import React from 'react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="border-y-4 border-brand-orange bg-white px-4 py-7" data-id="element-17" data-mp="1og3zh07r0h54">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="1oi81tdq0183a">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-19" data-mp="22fwmakg5md7t">
          <span aria-hidden="true" data-id="element-20" data-mp="1yejh8ckvye1y">🎁</span> In più riceverai 5 bonus esclusivi
        </h2>

        <div className="mt-4 space-y-3" data-id="element-21" data-mp="1ap8mpcu4pfw9">
          {bonuses.map(bonus => <article key={bonus.num} className="rounded-lg border-2 border-brand-orange/50 bg-brand-cream p-4" data-id="element-22" data-mp="15qfadnqkvuxo">
              <h3 className="font-display text-[15px] font-extrabold uppercase leading-tight text-brand-navy sm:text-base" data-id="element-23" data-mp="1jilshfdakbzr">
                <span aria-hidden="true" data-id="element-24" data-mp="qzy9q6lrp91u">🎁</span>{' '}
                <span className="text-brand-orange" data-id="element-25" data-mp="qyn9ggrj6jfh">BONUS {bonus.num}</span> —{' '}
                {bonus.title}
              </h3>

              <div className="mt-2 space-y-1.5 text-sm font-medium leading-snug text-brand-graphite" data-id="element-26" data-mp="29sct94dc40hx">
                {bonus.intro.map(line => <p key={line} data-id="element-27" data-mp="2eplcz9e4scla">{line}</p>)}
              </div>

              {bonus.chips && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-28" data-mp="2jio7bjqqfq2j">
                  {bonus.chips.map(chip => <li key={chip} className="rounded border border-brand-orange/30 bg-white px-2 py-1 text-[12px] font-semibold leading-tight text-brand-navy" data-id="element-29" data-mp="2oj2aandh89tp">
                      {chip}
                    </li>)}
                </ul>}

              {bonus.outro && <div className="mt-2 space-y-1 text-sm font-medium leading-snug text-brand-graphite" data-id="element-30" data-mp="25r9hasyeqolz">
                  {bonus.outro.map(line => <p key={line} data-id="element-31" data-mp="3h5ejbgf28oeo">{line}</p>)}
                </div>}
            </article>)}
        </div>
      </div>
    </section>;
}